/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApiKeyRenewalResponse } from '../models/api-key-renewal-response';
import { renewApiKey } from '../fn/api-keys/renew-api-key';
import { RenewApiKey$Params } from '../fn/api-keys/renew-api-key';

@Injectable({ providedIn: 'root' })
export class ApiKeysService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `renewApiKey()` */
  static readonly RenewApiKeyPath = '/api-keys-storage/renew';

  /**
   * Renew api key of organization by given dlssessionid in header.
   *
   * Renew the api key for the organization of the requesting user by using the dlssessionid in header.
   * It increase the expiry time to (DATE_NOW + 1 year). It also adds new organization sites to the api key.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `renewApiKey()` instead.
   *
   * This method doesn't expect any request body.
   */
  renewApiKey$Response(params?: RenewApiKey$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiKeyRenewalResponse>> {
    const obs = renewApiKey(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Renew api key of organization by given dlssessionid in header.
   *
   * Renew the api key for the organization of the requesting user by using the dlssessionid in header.
   * It increase the expiry time to (DATE_NOW + 1 year). It also adds new organization sites to the api key.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `renewApiKey$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  renewApiKey(params?: RenewApiKey$Params, context?: HttpContext): Observable<ApiKeyRenewalResponse> {
    const resp = this.renewApiKey$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ApiKeyRenewalResponse>): ApiKeyRenewalResponse => r.body)
    );
  }

}
